import { Util } from "./Util";

/** Fired when this tab should show re-auth without leaving the current page. */
export const SESSION_EXPIRED_EVENT = "mole:session-expired";

export const announceSessionExpired = () => {
	if (typeof window === "undefined") return;
	window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
};

/**
 * Close the re-auth UI only when a *new* usable token appears.
 * Closing because the rejected JWT still decodes locally is what made the
 * login modal flicker on POS: 401 → modal → “token looks fine” → close →
 * queued retries 401 again.
 */
export const isFreshSessionToken = (
	currentToken: string | null | undefined,
	rejectedToken: string | null | undefined,
): boolean => {
	if (!currentToken || !Util.isAccessTokenUsable(currentToken)) return false;
	if (!rejectedToken) return true;
	return currentToken !== rejectedToken;
};

/** True when the API is talking about the JWT / session, not a business 422. */
export const isJwtSessionFailureMessage = (message: unknown): boolean => {
	const text = String(message || "").toLowerCase();
	if (!text) return false;
	return (
		text.includes("token") ||
		text.includes("jwt") ||
		text.includes("expired") ||
		text.includes("authenticat") ||
		text.includes("signature") ||
		text.includes("not enough segments") ||
		text.includes("suspended")
	);
};

/**
 * Open the re-auth modal only for a dead local JWT, or a server answer that
 * actually names the session. A bare 401/422 (POS /work_sessions, validation)
 * must not cover the till with a login form.
 */
export const shouldOpenReauthModal = (
	currentToken: string | null | undefined,
	message: unknown,
	status?: number,
): boolean => {
	if (!currentToken || !Util.isAccessTokenUsable(currentToken)) return true;
	if (status === 401 || status === 422) {
		return isJwtSessionFailureMessage(message);
	}
	return isJwtSessionFailureMessage(message);
};
